/** X 轴类目标签旋转（echarts xAxis.axisLabel.rotate，单位：度） */
export function getXAxisLabelRotateDegrees (chartStyle) {
  const r = Number(chartStyle && chartStyle.xAxisLabelRotate)
  return Number.isFinite(r) ? r : 0
}

/**
 * 有旋转时加大底部 grid，避免类目文字被裁切（containLabel 仍可能不够）
 * @param {string} baseBottom 未旋转时的 bottom，需与各自 baseOption.grid.bottom 一致
 * @see chartStyle.xAxisLabelRotateBottomPercent 旋转时的底部留白占比（数字，默认 5 表示 5%，范围 5–80）
 */
export function gridBottomForXAxisLabelRotate (chartStyle, baseBottom) {
  const r = getXAxisLabelRotateDegrees(chartStyle)
  if (Math.abs(r) < 1e-6) return baseBottom
  const p = Number(chartStyle && chartStyle.xAxisLabelRotateBottomPercent)
  const pct = Number.isFinite(p) && p > 0
    ? Math.min(80, Math.max(5, Math.round(p)))
    : 5
  return `${pct}%`
}
